export const STRIPE_PRICES = {
  pro: {
    monthly: 'price_1TMbQZPhnrUwSqkvA9EvyYGT',
    yearly:  'price_1TMbPoPhnrUwSqkv5IlsG2jZ',
  },
  elite: {
    monthly: 'price_1TMbRsPhnrUwSqkvFqwbT4Sr',
    yearly:  'price_1TMbSDPhnrUwSqkvFE6704Oa',
  },
}

export const PLANS = [
  {
    id: 'free', name: 'Downrange Basic', emoji: '🎯',
    price: 0, yearly: 0, featured: false,
    description: 'Start calculating trajectories. Free forever.',
    features: [
      { text: '2 rifle profiles', included: true },
      { text: 'Basic ammo library', included: true },
      { text: 'Drop table calculator', included: true },
      { text: 'Terminal performance ratings', included: false },
      { text: 'Real-time GPS weather', included: false },
    ],
    priceIds: null,
  },
  {
    id: 'pro', name: 'Pro', emoji: '⚡',
    monthlyPrice: 4.99, yearlyPrice: 34.99, featured: true,
    description: 'The full DISDownrange experience.',
    features: [
      { text: 'Everything in Free', included: true },
      { text: 'Unlimited rifle profiles', included: true },
      { text: 'Full terminal performance data', included: true },
      { text: 'Real-time GPS weather', included: true },
      { text: 'Ethical range calculator', included: true },
      { text: 'Side-by-side comparison', included: true },
      { text: 'Shot log & auto-true model', included: false },
      { text: 'Terrain presets', included: false },
    ],
    priceIds: { monthly: 'price_1TMbQZPhnrUwSqkvA9EvyYGT', yearly: 'price_1TMbPoPhnrUwSqkv5IlsG2jZ' },
  },
  {
    id: 'elite', name: 'Elite', emoji: '💎',
    monthlyPrice: 9.99, yearlyPrice: 69.99, featured: false,
    description: 'Everything in Pro plus advanced features.',
    features: [
      { text: 'Everything in Pro', included: true },
      { text: 'Shot log & auto-true model', included: true },
      { text: 'Terrain presets', included: true },
      { text: 'Priority ammo updates', included: true },
      { text: 'First access to Phase 2', included: true },
    ],
    priceIds: { monthly: 'price_1TMbRsPhnrUwSqkvFqwbT4Sr', yearly: 'price_1TMbSDPhnrUwSqkvFE6704Oa' },
  },
]

export async function createCheckoutSession(priceId, userId, userEmail) {
  const res = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-checkout`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({ priceId, userId, userEmail }),
    }
  )
  if (!res.ok) throw new Error('Failed to create checkout session')
  const { url } = await res.json()
  return url
}

export function getTierLabel(tier) {
  switch (tier) {
    case 'pro':   return 'Pro'
    case 'elite': return 'Elite'
    default:      return 'Free'
  }
}

export function getTierColor(tier) {
  switch (tier) {
    case 'pro':   return '#5b9bd5'
    case 'elite': return '#c8a96e'
    default:      return '#666'
  }
}
